export const SET_LOADER_STATUS = 'SET_LOADER_STATUS';